module.exports = __webpack_public_path__ + "static/media/gl_delete_filled.6f0d240b.svg";